export default "__VITE_ASSET__C7Ojc4a5__"